export const CloseIcon = require('../../Icons/close-cross.svg').default;
